"use client";

export { useTina } from "tinacms/dist/react";
